import http from '@/http';

export default {

    list() {
        return http.get('/areas');
    },
    get(id) {
        return http.get(`/areas/${id}`);
    },
    save(form) {
        return http.post('/areas', form);
    },
    update(id, form) {
        return http.put(`/areas/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/areas.js